<div fxFlex fxLayout fxLayoutGap="25px" fxLayout.lt-md="column" fxLayoutAlign="center center"
  fxLayoutAlign.lt-md="center start">

  <div id="id_copy_condition_lbl">
    {{ 'LABEL_COPY_FROM' | translate }}
  </div>

  <div fxLayout>
    <form [formGroup]="form">
      <mat-form-field>
        <input matInput [placeholder]="currentStep" formControlName="duplicate" [matAutocomplete]="duplicateAC" (focus)="!duplicateAC.isOpen && getInitialValues('duplicate')" #duplicateInput>

        <!-- <mat-icon *ngIf="(duplicateInput.value != 'All')" matSuffix svgIcon="close-circle-outline" (click)="form.reset()"></mat-icon> -->

        <mat-icon matSuffix svgIcon="menu-down" *ngIf="(duplicateInput.value == 'All')"></mat-icon>

        <mat-icon 
          id="id_select_condition_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="duplicateInput.blur(); clearForm($event)"
          *ngIf="duplicateInput.value"
          >
        </mat-icon>

        <mat-autocomplete id="id_copy_condition_dropdown" #duplicateAC="matAutocomplete" [displayWith]="displayFn" (closed)="autoCmpltClosed()">
          <mat-option disabled *ngIf="!loading.duplicate && listData?.length == 0">
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <mat-option [id]="'id_copy_condition_data_' + (i+1)" [value]="data" matTooltipPosition="right" *ngFor="let data of listData; let i = index"
            [matTooltip]="data.description">
            {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.duplicate" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>

        </mat-autocomplete>

        <mat-error *ngIf="form.get('duplicate').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: currentStep} }}
        </mat-error>
      </mat-form-field>
    </form>

    <!-- <mat-icon svgIcon="content-copy">
    </mat-icon> -->
  </div>
  <div *ngIf="loading.merging" fxFlex fxLayout="column" fxLayoutAlign="center center" class="loading-indicator-wizard">
      <mat-spinner></mat-spinner>
    </div>
</div>